module.exports = __webpack_public_path__ + "img/bim (6).acf1f0c5.png";